import type { ComponentType } from 'react';

export type PageLoader = () => Promise<{ default: ComponentType }>;

/** The app's pages (filled in by the router), for loading ahead of time. */
export const appPages: PageLoader[] = [];

let started = false;

/**
 * Loads the code of the app's pages one after another while the browser is idle, so opening one
 * later doesn't wait for it. Runs once.
 */
export function preloadPages() {
  if (started) return;
  started = true;
  const idle = (fn: () => void) =>
    'requestIdleCallback' in window
      ? window.requestIdleCallback(fn, { timeout: 2000 })
      : setTimeout(fn, 50);
  const queue = [...appPages];
  const next = () => {
    const load = queue.shift();
    if (load) idle(() => void load().then(next, next));
  };
  next();
}
